export const retryImport = (path: string) => {
  return import(path);
};
